"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ModuleUtil {
    static mergeConfigurations(moduleConfigurationMetadata, propertyConfiguration) {
        if (!propertyConfiguration) {
            return moduleConfigurationMetadata;
        }
        const defaultKeys = Object.keys(moduleConfigurationMetadata);
        const unknownKeys = Object.keys(propertyConfiguration).filter(key => !defaultKeys.includes(key));
        for (const unknownKey of unknownKeys) {
            moduleConfigurationMetadata[unknownKey] = {
                propertyValue: propertyConfiguration[unknownKey],
                unknownProperty: true
            };
        }
        return Object.entries(moduleConfigurationMetadata)
            .reduce((sum, [key, configProperty]) => {
            const overrideEntriesKeyType = key;
            sum[overrideEntriesKeyType] = configProperty;
            const currentValue = propertyConfiguration[overrideEntriesKeyType];
            if (currentValue !== undefined) {
                sum[overrideEntriesKeyType].propertyValue = currentValue;
            }
            return sum;
        }, {});
    }
    static getConfig(moduleConfigMetadata) {
        return Object.entries(moduleConfigMetadata)
            .reduce((sum, [key, configProperty]) => {
            // Object.entries has a bad type implementation. It assumes the key always is string rather than keyof T
            sum[key] = configProperty.propertyValue !== undefined
                ? configProperty.propertyValue
                : configProperty.defaultValue;
            return sum;
        }, {});
    }
}
exports.default = ModuleUtil;
//# sourceMappingURL=ModuleUtil.js.map